function importAll(r) {
  let images = {};
  r.keys().forEach((key) => {
    images[key] = r(key); // keep the "./file.svg" format
  });

  // return a function that looks up by key
  return (name) => images[name];
}

const flagSvgs = importAll(
  require.context("../assets/flags-svg", false, /\.svg$/)
);

export default flagSvgs;
